<template>
  <div>
    <div
      id="stock-videos'"
      class="thumbnail-box-conatiner mt-20">
      <div
        v-masonry
        id="videoStockMasonry"
        class="image-container"
        transition-duration="0"
        item-selector=".image-wrapper"
        gutter="10">

        <div
          v-masonry-tile
          v-for="(audio, index) in audios"
          :key="index"
          class="image-wrapper">
          <div
            class="image-item thumbnail-border cursor-pointer"
            @click="insertAudioToCanvas(audio)">
            <img
              :src="audio.thumbnail"
              style="width: 30%">{{ audio.Name }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  name:       'StockAudioBox',
  components: { Spinner },
  data() {
    return {
      audios: [
        {
          Name:      'sample1.mp3',
          thumbnail: 'https://samples-files.com/wp-content/uploads/2023/03/sample-mp3-file.png',
          duration:  122.12,
          mimeType:  'audio/mp3',
          audioUrl:  'https://filesamples.com/samples/audio/mp3/sample1.mp3',

        },
        {
          Name:      'wave.mp3',
          thumbnail: 'https://samples-files.com/wp-content/uploads/2023/03/sample-mp3-file.png',
          duration:  45.32,
          mimeType:  'audio/mp3',
          audioUrl:  'https://sample-videos.com/audio/mp3/wave.mp3',

        },
        {
          Name:      'sample-file-4.mp3',
          thumbnail: 'https://samples-files.com/wp-content/uploads/2023/03/sample-mp3-file.png',
          duration:  19.74,
          mimeType:  'audio/mp3',
          audioUrl:  'https://samples-files.com/samples/Audio/mp3/sample-file-4.mp3',

        },
        {
          Name:      'Kahani-Suno.mp3',
          thumbnail: 'https://samples-files.com/wp-content/uploads/2023/03/sample-mp3-file.png',
          duration:  173.71,
          mimeType:  'audio/mp3',
          audioUrl:  'https://aslihiphop.com/lyrics/wp-content/uploads/2022/08/Kaifi-Khalil-Kahani-Suno-2.0-Official-Music-Video.mp3',

        },
        {
          Name:      'best-airtel-tone.mp3',
          thumbnail: 'https://samples-files.com/wp-content/uploads/2023/03/sample-mp3-file.png',
          duration:  18.98,
          mimeType:  'audio/mp3',
          audioUrl:  'https://ring.techbigs.download/files/best-airtel-tone.mp3',

        },
        {
          Name:      'bollywood-instrumental.mp3',
          thumbnail: 'https://samples-files.com/wp-content/uploads/2023/03/sample-mp3-file.png',
          duration:  24.11,
          mimeType:  'audio/mp3',
          audioUrl:  'https://ring.techbigs.download/files/new-bollywood-instrumental.mp3',

        },
        {
          Name:      'titanic-flute.mp3',
          thumbnail: 'https://samples-files.com/wp-content/uploads/2023/03/sample-mp3-file.png',
          duration:  20.48,
          mimeType:  'audio/mp3',
          audioUrl:  'https://ring.techbigs.download/files/titanic-flute.mp3',

        },
        {
          Name:      'very-sad-instrumental.mp3',
          thumbnail: 'https://samples-files.com/wp-content/uploads/2023/03/sample-mp3-file.png',
          duration:  29.02,
          mimeType:  'audio/mp3',
          audioUrl:  'https://ring.techbigs.download/files/very-sad-instrumental.mp3',

        },
      ],
    };
  },
  computed: {
    getAudios() {
      return this.audios;
    },
  },
  methods: {
    insertAudioToCanvas(audioObj) {
      audioObj.startTime    = 0;
      audioObj.endTime      = audioObj.duration;
      audioObj.fadeIn       = 0;
      audioObj.fadeOut      = audioObj.duration;
      audioObj.trimDuration = audioObj.duration;
      EventBus.$emit(ApplicationEventTypes.Audio.ADD_NEW_AUDIO, audioObj);
      EventBus.$emit('toggleAudioLeftSectionAccordion', true);
      EventBus.$emit('selectAudioLayerFromLeftSection', true);
      this.$store.commit('setDisplayAddAudioModal', false);
    },
  },
};
</script>

<style scoped lang="scss">

.thumbnail-box-conatiner {
  max-height: calc(100vh - 300px);
  overflow: auto;
  padding: 0px 20px;

  .image-container {
    /*column-width: 14vw;
    grid-auto-flow: dense;*/
    margin-top: 10px;
    min-height: 412px;

    .image-wrapper {
      width: calc(25% - 10px);
      margin-bottom: 20px;
    }

    .video-item {
      transition: all 0.2s;
      cursor: pointer;
      position: relative;
      margin-bottom: 10px;
      float: left;

      &:hover {
        .image-delete-button {
          opacity: 1 !important;
        }
      }

      .image-delete-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 3px;
        opacity: 0;
        height: 24px;
        width: 24px;
      }

      video, img {
        &:hover {
          box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.2);
          opacity: 1;
        }

        width: 100%;
        margin-bottom: 0;
        border-radius: 10px !important;
        float: left;
      }

      .thumbnail-border {
        border: 2px solid #3bb0fa !important
      }
    }


  }

  .inner-Loader {
    width: calc(100% - 80px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 56;
    top: 210px;
    bottom: 2vh;

    .vue-simple-spinner-text {
      color: #52A7E1 !important
    }
  }
}
.cursor-pointer{
  cursor: pointer;
}
</style>
